import { apiClient } from "./ApiClient";
import { Office } from "../types";

interface ApiOffice {
  id: number;
  name: string;
}

interface ApiOfficesResponse {
  data: ApiOffice[];
}

export class OfficeService {
  static async getOffices(): Promise<Office[]> {
    const response = await apiClient.get<ApiOfficesResponse>("/offices");
    return response.data.map((o) => ({
      id: o.id.toString(),
      name: o.name,
    }));
  }
}
